var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    class: _vm.$style.form
  }, [_c('labeled-input', {
    directives: [{
      name: "m-b",
      rawName: "v-m-b",
      value: 10,
      expression: "10"
    }],
    attrs: {
      "error": _vm.$v.form.code.$error,
      "force-replace": _vm.projectСodeReplacementRules,
      "label": _vm.$t('project.id'),
      "maxlength": 255
    },
    on: {
      "focus": _vm.$v.form.code.$reset,
      "blur": _vm.$v.form.code.$touch
    },
    model: {
      value: _vm.form.code,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "code", $$v);
      },
      expression: "form.code"
    }
  }), _c('labeled-input', {
    directives: [{
      name: "m-b",
      rawName: "v-m-b",
      value: 10,
      expression: "10"
    }],
    attrs: {
      "label": _vm.$t('token.for.api'),
      "data-private": "",
      "disabled": ""
    },
    model: {
      value: _vm.form.merchantToken,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "merchantToken", $$v);
      },
      expression: "form.merchantToken"
    }
  }), _c('labeled-input', {
    directives: [{
      name: "m-b",
      rawName: "v-m-b",
      value: 10,
      expression: "10"
    }],
    attrs: {
      "label": "Callback URL",
      "placeholder": "https://yoursite.com/callback",
      "maxlength": 255,
      "error": _vm.$v.form.callbackUrl.$error
    },
    on: {
      "focus": _vm.$v.form.callbackUrl.$reset,
      "blur": _vm.$v.form.callbackUrl.$touch
    },
    model: {
      value: _vm.form.callbackUrl,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "callbackUrl", $$v);
      },
      expression: "form.callbackUrl"
    }
  }), _c('option-panel', {
    directives: [{
      name: "m-b",
      rawName: "v-m-b",
      value: 10,
      expression: "10"
    }, {
      name: "background-color",
      rawName: "v-background-color:dark-blue-2",
      arg: "dark-blue-2"
    }],
    on: {
      "click": _vm.handleChangeCallbackMethod
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    domProps: {
      "textContent": _vm._s(_vm.form.callbackMethod)
    },
    slot: "title"
  }), _c('span', {
    attrs: {
      "slot": "description"
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('payment.technical.callback.method'))
    },
    slot: "description"
  }), _c('simple-button', {
    directives: [{
      name: "p-l",
      rawName: "v-p-l",
      value: 40,
      expression: "40"
    }, {
      name: "p-r",
      rawName: "v-p-r",
      value: 40,
      expression: "40"
    }],
    attrs: {
      "slot": "action",
      "variant": "darken",
      "size": "small"
    },
    slot: "action"
  }, [_vm._v(" " + _vm._s(_vm.$t('common.change')) + " ")])], 1), _c('labeled-input', {
    directives: [{
      name: "m-b",
      rawName: "v-m-b",
      value: 10,
      expression: "10"
    }],
    attrs: {
      "label": "Success URL",
      "placeholder": "https://yoursite.com/callback",
      "maxlength": 255,
      "error": _vm.$v.form.successUrl.$error
    },
    on: {
      "focus": _vm.$v.form.successUrl.$reset,
      "blur": _vm.$v.form.successUrl.$touch
    },
    model: {
      value: _vm.form.successUrl,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "successUrl", $$v);
      },
      expression: "form.successUrl"
    }
  }), _c('labeled-input', {
    attrs: {
      "label": "Fail URL",
      "placeholder": "https://yoursite.com/callback",
      "maxlength": 255,
      "error": _vm.$v.form.failUrl.$error
    },
    on: {
      "focus": _vm.$v.form.failUrl.$reset,
      "blur": _vm.$v.form.failUrl.$touch
    },
    model: {
      value: _vm.form.failUrl,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "failUrl", $$v);
      },
      expression: "form.failUrl"
    }
  }), _c('cs-switcher', {
    directives: [{
      name: "m-t",
      rawName: "v-m-t",
      value: 10,
      expression: "10"
    }],
    attrs: {
      "label": _vm.$t('payment.auto.redirection.switcher.label')
    },
    on: {
      "input": _vm.handleChangePaymentAutoRedirection
    },
    model: {
      value: _vm.form.paymentAutoRedirection,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "paymentAutoRedirection", $$v);
      },
      expression: "form.paymentAutoRedirection"
    }
  })], 1), _c('div', {
    class: _vm.$style.submit
  }, [_c('simple-button', {
    attrs: {
      "variant": "primary",
      "disabled": !_vm.isValid
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.save')) + " ")])], 1), _c('payment-auto-redirection-alert'), _c('callback-message-method-dialog', {
    on: {
      "select-callback-method": _vm.handleSelectCallbackMethod
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }